
import IssuesModel from '../models/IssuesModel'
import moment from 'moment'

const dateFormat = 'YYYY/MM/DD'
const format = 'HH:mm'

const issue = (state, action) => {

    if (!state) {
        state = {
            step: 0,
            data: IssuesModel.dispense(),
            complete: false,
            error: '',
            caop: null
        }
    }

    switch (action.type) {
        case 'ISSUE_OPEN_FORM':
        action.formData.attach_a = state.data.attach_a;
        return {
            step: 0,
            data: action.formData,
            complete: false,
            error: '',
            caop: null
        }
        case 'ISSUE_CHANGE_STEP':
        return {
            ...state,
            step: action.step,
            complete: false,
            error: '',
            caop: null
        }
        case 'ISSUE_MAP_SET_CENTER':
        return {
            ...state,
            caop: action.caop ? action.caop : state.caop,
            data: {
                ...state.data,
                mapZoom: action.zoom,
                mapCenter: action.center
            }
        }
        case 'ISSUE_SET_ANONYMOUS':
        return {
            ...state,
            data: {
                ...state.data,
                attach_a: true,
                issue_date: moment().format(dateFormat),
                issue_time: moment().format(format),
                issue_reg_local_date: moment().format(dateFormat),
                issue_reg_local_time: moment().format(format)
            }
        }
        case 'ISSUE_UPDATE_FORM':
        return {
            ...state,
            data: action.formData,
            complete: action.complete,
            error: action.error,
            caop: null
        }
        default:
        return state
    }
}

export default issue



// WEBPACK FOOTER //
// ./src/reducers/issueForm.js